import { observer, useLocalObservable } from 'mobx-react-lite'
import SupportTicketForm from './SupportTicketForm'
import makeQuery from 'api/makeQuery'
import SupportTicketConfirmation from './SupportTicketConfirmation'
import GeneralInformation from './GeneralInformation'

const HelpCenter = () => {
  const store = useLocalObservable(() => ({
    showTicketConfirmation: false,
    ticketId: '',
    async createTicket(type, details) {
      const response = await makeQuery('postSupportTicket', {
        type,
        details,
      })
      if (response) {
        this.setTicketId(response.ticketId)
        this.setShowTicketConfirmation(true)
      }
    },
    setTicketId(ticketId) {
      this.ticketId = ticketId
    },
    setShowTicketConfirmation(showTicketConfirmation) {
      this.showTicketConfirmation = showTicketConfirmation
    },
  }))

  const cardClassName = 'w-full max-w-[648px] rounded-lg shadow-lg'

  return (
    <div className="flex flex-col items-center gap-7 px-4 pt-14 pb-12">
      {!store.showTicketConfirmation ? (
        <>
          <div className={cardClassName}>
            <SupportTicketForm createTicket={store.createTicket} />
          </div>
          <div className={cardClassName}>
            <GeneralInformation />
          </div>
        </>
      ) : (
        <div className={cardClassName}>
          <SupportTicketConfirmation ticketId={store.ticketId} onClose={() => store.setShowTicketConfirmation(false)} />
        </div>
      )}
    </div>
  )
}

export default observer(HelpCenter)
